import { useFormContext } from 'react-hook-form';
import { useTranslation } from '@/utils/i18n/useTranslation';
import { useContext } from 'react';
import { UserContext } from '@/context/UserContext';

interface FormErrorProps {
  children?: string;
  modifiers?: string[];
}

const FormItemError = (props: FormErrorProps) => {
  const { children, modifiers } = props;

  const userContext = useContext(UserContext);

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : '';

  /* eslint-disable @typescript-eslint/no-unnecessary-condition -- optimistic GraphQL type — this guard defends a null the generated type doesn't model; re-type from codegen to remove */
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT,
  );
  /* eslint-enable @typescript-eslint/no-unnecessary-condition */

  const { formState } = useFormContext();

  return (
    children &&
    formState.isSubmitted && (
      <div className={`FormError${modifierClasses}`}>
        <p className="FormError-copy">{t(children)}</p>
      </div>
    )
  );
};

export default FormItemError;
